import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import PublicReceipt from './modules/receipt/PublicReceipt';
import reportWebVitals from './reportWebVitals';
// Public bills must not evaluate POS modules that connect sockets on import.
const PosAppRoot = lazy(() => import('./PosAppRoot'));
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(window.location.pathname.startsWith('/receipt/') ? <PublicReceipt />
  : <Suspense fallback={<p role="status">Loading RestroDesk…</p>}><PosAppRoot /></Suspense>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
